import { useAppContext } from '@pkgs/components/hooks/useAppContext';
import { useSearchStore } from '@pkgs/components/hooks/stores/search/useSearchStore';
import { Select } from '@pkgs/components/components/Select/Select';
import { type InputTextSizesProps } from '@ev-tech/ui-core-components/InputText';
import { MeasurementSystem } from '@ev-tech/search-modules-api';

import { extendedRadiusValuesImperial, extendedRadiusValuesMetric } from '../searchRadiusSelectItems';

type ExtendedRadiusFilterProps = {
  hasLabelHidden?: boolean;
  size?: InputTextSizesProps;
  className?: string;
  isInModal?: boolean;
  'data-testid'?: string;
  'data-hidden'?: boolean;
};
export const ExtendedRadiusFilter = ({
  size,
  className,
  isInModal,
  hasLabelHidden,
  'data-testid': dataTestId,
  'data-hidden': dataHidden,
}: ExtendedRadiusFilterProps) => {
  const {
    t,
    options: { measurementSystem },
  } = useAppContext();
  const searchRadius = useSearchStore((state) => state.searchRadius);
  const setSearchRadius = useSearchStore((state) => state.setSearchRadius);

  const extendedRadiusValues = measurementSystem === MeasurementSystem.imperial ? extendedRadiusValuesImperial : extendedRadiusValuesMetric;

  const unitTranslation =
    measurementSystem === MeasurementSystem.imperial ? t('search.common.unit.mile') : t('search.common.unit.kilometer');

  return (
    <Select
      data-hidden={dataHidden}
      accessibilityLabel={t('search.select.hiddenAccessibilityText', {
        label: t('search.common.extendedRadius.label'),
      })}
      className={className}
      items={extendedRadiusValues.map((item) => ({
        id: item.id.toString(),
        label: `${item.label} ${unitTranslation}`,
      }))}
      onChange={(value) => setSearchRadius(Number(value))}
      label={t('search.common.extendedRadius.label')}
      placeholder={t('search.common.extendedRadius.label')}
      value={searchRadius ? searchRadius.toString() : '0'}
      name="searchRadius"
      hasLabelHidden={hasLabelHidden}
      size={size}
      isInModal={isInModal}
      data-testid={dataTestId}
      variant="basicLightV2"
      arrowVariant="small"
      offset={3}
    />
  );
};
